import { Outlet } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import { FavoritesProvider } from "@/context/FavoritesContext";

export default function SiteLayout() {
  return (
    <FavoritesProvider>
      <div className="flex min-h-screen w-full flex-col bg-background-50">
        <SiteHeader />
        <main className="flex-1">
          <Outlet />
        </main>
        <SiteFooter />
      </div>
    </FavoritesProvider>
  );
}